/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Automatic_Transcription_DialogInputs */

const en_close_automatic_transcription_dialog = /** @type {(inputs: Close_Automatic_Transcription_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close automatic transcription dialog`)
};

const fr_close_automatic_transcription_dialog = /** @type {(inputs: Close_Automatic_Transcription_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la fenêtre de transcription automatique`)
};

const de_close_automatic_transcription_dialog = /** @type {(inputs: Close_Automatic_Transcription_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisches Transkriptionsdialogfeld schließen`)
};

const it_close_automatic_transcription_dialog = /** @type {(inputs: Close_Automatic_Transcription_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi la finestra di dialogo della trascrizione automatica`)
};

const ru_close_automatic_transcription_dialog = /** @type {(inputs: Close_Automatic_Transcription_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть диалоговое окно автоматической транскрипции`)
};

const es_close_automatic_transcription_dialog = /** @type {(inputs: Close_Automatic_Transcription_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar el cuadro de diálogo de transcripción automática`)
};

const zh_cn2_close_automatic_transcription_dialog = /** @type {(inputs: Close_Automatic_Transcription_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭自动转录对话框`)
};

const ja_close_automatic_transcription_dialog = /** @type {(inputs: Close_Automatic_Transcription_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動転写ダイアログを閉じる`)
};

const hi_close_automatic_transcription_dialog = /** @type {(inputs: Close_Automatic_Transcription_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित प्रतिलेखन संवाद बंद करें`)
};

const pt_pt2_close_automatic_transcription_dialog = /** @type {(inputs: Close_Automatic_Transcription_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar caixa de diálogo de transcrição automática`)
};

/**
* | output |
* | --- |
* | "Close automatic transcription dialog" |
*
* @param {Close_Automatic_Transcription_DialogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_automatic_transcription_dialog = /** @type {((inputs?: Close_Automatic_Transcription_DialogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Automatic_Transcription_DialogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_close_automatic_transcription_dialog(inputs)
	if (locale === "de") return de_close_automatic_transcription_dialog(inputs)
	if (locale === "it") return it_close_automatic_transcription_dialog(inputs)
	if (locale === "ru") return ru_close_automatic_transcription_dialog(inputs)
	if (locale === "es") return es_close_automatic_transcription_dialog(inputs)
	if (locale === "zh-CN") return zh_cn2_close_automatic_transcription_dialog(inputs)
	if (locale === "ja") return ja_close_automatic_transcription_dialog(inputs)
	if (locale === "hi") return hi_close_automatic_transcription_dialog(inputs)
	if (locale === "pt-PT") return pt_pt2_close_automatic_transcription_dialog(inputs)
	return en_close_automatic_transcription_dialog(inputs)
});